import { Pipe, PipeTransform } from '@angular/core';

import {Moment, MomentInput, unitOfTime} from 'jalali-moment';
import * as momentNs from 'jalali-moment';
const moment = momentNs;


@Pipe({
    name: 'defaultDate'
})
export class DefaultDatePipe implements PipeTransform {
    public transform(date: Moment) {

        if (date == null) {
            moment.locale("fa");
            date = moment();
        }

        return date;
    }
}